import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/unsubscribe")({
  component: UnsubscribePage,
});

function UnsubscribePage() {
  const params = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
  const token = params.get("token") ?? "";
  const [state, setState] = useState<"loading" | "valid" | "done" | "already" | "invalid">(
    "loading",
  );
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) {
      setState("invalid");
      return;
    }
    fetch(`/email/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.valid) setState("valid");
        else if (d.reason === "already_unsubscribed") setState("already");
        else setState("invalid");
      })
      .catch(() => setState("invalid"));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try {
      const res = await fetch("/email/unsubscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
      const d = await res.json();
      if (d.success) setState("done");
      else if (d.reason === "already_unsubscribed") setState("already");
      else setState("invalid");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-4 p-8 rounded-2xl border border-border bg-card">
        <h1 className="text-2xl font-bold">Отписка от писем</h1>
        {state === "loading" && <p className="text-muted-foreground">Проверяем ссылку…</p>}
        {state === "invalid" && (
          <p className="text-muted-foreground">Ссылка недействительна или устарела.</p>
        )}
        {state === "already" && (
          <p className="text-muted-foreground">Вы уже отписаны от рассылки.</p>
        )}
        {state === "valid" && (
          <>
            <p className="text-muted-foreground">Нажмите кнопку, чтобы подтвердить отписку.</p>
            <button
              onClick={confirm}
              disabled={busy}
              className="inline-flex items-center justify-center rounded-lg bg-primary text-primary-foreground px-6 py-3 font-medium hover:opacity-90 disabled:opacity-50"
            >
              {busy ? "Отписываем…" : "Подтвердить отписку"}
            </button>
          </>
        )}
        {state === "done" && <p className="text-muted-foreground">Готово. Вы отписаны от писем.</p>}
      </div>
    </div>
  );
}
